import { TextField } from "@material-ui/core";
import React, { Component } from "react";
import { Row, Col, Container, Table, Modal, Button } from "react-bootstrap";
import { FormControl, Select, InputLabel } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import { TableBodyAll } from "./AllReservationTable/TableBodyAll";
import { TableHeadAll } from "./AllReservationTable/TableHeadAll";

class AllReservations extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      nodata: false,
    };
  }
  render() {
    const { open, nodata } = this.state;
    return (
      <React.Fragment>
        <Container fluid>
          <Row>
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText={"vendorReview"}
                backButtonLink="/manage-block-reservation-calendar"
                displayText="Back"
              />
              <div className="container-fluid seating_dashboard_top_new_header">
                <div className="d-flex justify-content-between align-items-center pt-4 pb-4">
                  <div className="f24_700_HelveticaNeue">
                    All Reservations
                    <div style={{ fontSize: "14px", fontWeight: "normal" }}>
                      Manage your reservation according to your availability
                      schedule
                    </div>
                  </div>
                  <NavLink
                    to="/all-reservations"
                    className="btn btn-danger btn2 btn-lg"
                    style={{
                      backgroundColor: "#EE3A23",
                      borderColor: "#EE3A23",
                    }}
                    onClick={() => {
                      this.setState({ open: true });
                    }}
                  >
                    Cancel all Below
                  </NavLink>
                </div>
              </div>
              {nodata ? (
                <div
                  style={{
                    height: "72px",
                    width: "100%",
                    background: "#FFFFFF",
                    boxShadow: "0px 3px 6px #6E6E6E21",
                    borderRadius: "5px",
                    fontSize: "1.5rem",
                    fontWeight: "bold",
                    alignItems: "center",
                  }}
                  align="center"
                >
                  No records to show
                </div>
              ) : (
                <>
                  <div className="container-fluid seating-dashboard-desktop-table">
                    <Table>
                      <TableHeadAll />
                    </Table>
                  </div>
                  <div className="container-fluid">
                    <Table>
                      <TableBodyAll
                        dinerInfo={data[0].dinerInfo}
                        dinerName={data[0].dinerName}
                        displayCall={true}
                        displaySms={true}
                        displayNotification={true}
                        displayChat={true}
                        displayViewDiner={true}
                        displayEditDiner={true}
                        //   // dinerName={data.user_details.name}
                        //   // dinerRequestId={`#${data.diner_id}`}
                        //   // dinerStatus={data.diner_status}
                        //   // seatingPreference={data.seating_preference[0]}
                        //   // roomNumber={data.room_number}
                        //   // tableNumber={data.table_number}
                        //   // occasion={data.occasion}
                        //   // orderType="waitlist"
                        //   // totalCount={data.adult_count + data.kids_count}
                        //   // totalAdult={data.adult_count}
                        //   // totalKids={data.kids_count}
                        //   // totalHighchair={data.high_chair}
                        //   // totalHandicapped={data.handicap_chair}
                        //   // status={data.diner_status}
                        sendDataDinerProps={data[0].sendDataDinerProps}
                      />
                    </Table>
                  </div>
                </>
              )}
            </div>
            <CancelAllModel
              open={open}
              closeModel={() => {
                this.setState({ open: false });
              }}
              cancelAll={() => {
                this.setState({ nodata: true });
              }}
            />
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

const CancelAllModel = (props) => {
  const [stage, setStage] = React.useState(0);
  return (
    <React.Fragment>
      <Modal
        show={props.open}
        onHide={() => {
          props.closeModel();
        }}
        centered
        size="md"
      >
        <Modal.Header className="border-0 pl-4" closeButton>
          <Modal.Title className="f24-700">
            {stage === 0 ? "Reason for Cancellation" : "Cancelation Complete"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4 f16-500">
          {stage === 0 ? (
            <>
              <div>
                <FormControl variant="outlined" style={{ minWidth: "100%" }}>
                  {/* <InputLabel htmlFor="outlined-time">Reservation Time</InputLabel> */}
                  <Select
                    value={""}
                    // onChange={selecthandleChange}
                    // label="Reason"
                    inputProps={{
                      name: "reason",
                      // id: "outlined-time",
                    }}
                    // IconComponent={KeyboardArrowDownIcon}
                  >
                    <option value={""}>Mass Cancel due to Block</option>
                  </Select>
                </FormControl>
              </div>
              <br />
              <div>
                <b>Notify all the users with reservation</b>
                <br />
                <TextField
                  multiline
                  rows="4"
                  variant="outlined"
                  fullWidth
                  placeholder="Shop Closed due to lockdown"
                />
              </div>
              <div className="d-flex align-items-center pt-4">
                <Button
                  variant="outline-secondary"
                  className="btn150px btn-lg mr-4 px-5"
                >
                  Cancel
                </Button>
                <NavLink to="/all-reservations">
                  <Button
                    variant="danger"
                    className="btn150px btn-lg px-5"
                    onClick={() => {
                      props.cancelAll();
                      setStage(1);
                    }}
                  >
                    Send
                  </Button>
                </NavLink>
              </div>
            </>
          ) : (
            <div>Your reservations has been canceled for today.</div>
          )}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

const data = [
  {
    dinerInfo: {
      _id: "6001dfe5acec550259b0e3aa",
      seating_preference: ["Rooftop Seating"],
      diner_status: "NOTSEATED",
      isTempUser: true,
      isWalkIn: false,
      userConfirmed: false,
      cancelByVendor: false,
      same_party_size: false,
      vendor_id: "5f8ac1f8c0aac52d42af60a8",
      kids_count: 2,
      adult_count: 3,
      handicap_chair: 0,
      high_chair: 0,
      room_number: 2,
      table_number: 2,
      occasion: "test dummy",
      wait_time: 5,
      service_type: "SEATING",
      pointOfEntry: "VENDOR",
      user_details: {
        country_code: "+91",
        deviceToken: "",
        mobile_number: "7049892303",
        name: "Gaurav Shinde",
      },
      diner_id: "575033",
      user_id: "5fcf7ae8984be25173c905f9",
      auditLogs: [
        {
          _id: "6001dfe5acec550259b0e3ab",
          message:
            "Sujit booked a table for 1 adults and 1 kids with 0 highchairs requested.",
          initiator: "Sujit",
          timestamp: "2021-01-15T18:33:09.284Z",
          auditStatus: "NOTSEATED",
        },
      ],
      createdAt: "2021-01-15T18:33:09.288Z",
      updatedAt: "2021-01-16T08:05:58.794Z",
      __v: 0,
    },
    dinerName: "Gaurav Shinde",
    displayCall: true,
    displaySms: true,
    displayNotification: true,
    displayChat: true,
    displayViewDiner: true,
    displayEditDiner: true,
    sendDataDinerProps: {
      _id: "6001dfe5acec550259b0e3aa",
      seating_preference: ["Rooftop Seating"],
      diner_status: "NOTSEATED",
      isTempUser: true,
      isWalkIn: false,
      userConfirmed: false,
      cancelByVendor: false,
      same_party_size: false,
      vendor_id: "5f8ac1f8c0aac52d42af60a8",
      kids_count: 2,
      adult_count: 3,
      handicap_chair: 0,
      high_chair: 0,
      room_number: 2,
      table_number: 2,
      occasion: "test dummy",
      wait_time: 5,
      service_type: "SEATING",
      pointOfEntry: "VENDOR",
      user_details: {
        country_code: "+91",
        deviceToken: "",
        mobile_number: "7049892303",
        name: "Gaurav Shinde",
      },
      diner_id: "575033",
      user_id: "5fcf7ae8984be25173c905f9",
      auditLogs: [
        {
          _id: "6001dfe5acec550259b0e3ab",
          message:
            "Sujit booked a table for 1 adults and 1 kids with 0 highchairs requested.",
          initiator: "Sujit",
          timestamp: "2021-01-15T18:33:09.284Z",
          auditStatus: "NOTSEATED",
        },
      ],
      createdAt: "2021-01-15T18:33:09.288Z",
      updatedAt: "2021-01-16T08:05:58.794Z",
      __v: 0,
    },
  },
];

export default AllReservations;
